var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { PlaceholderBtn } from "./PlaceholderBtn";
import { PlaceholderInfo } from "./PlaceholderInfo";
var Placeholder = /** @class */ (function (_super) {
    __extends(Placeholder, _super);
    function Placeholder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Placeholder.prototype.renderItems = function (eventsCount) {
        var elements = [];
        for (var i = 1; i <= eventsCount; i++) {
            elements.push(React.createElement("div", { key: "placeholder_item_" + i, className: "rj-ev-list__placeholder__card-items-wrap" },
                React.createElement(PlaceholderInfo, null),
                React.createElement(PlaceholderBtn, null)));
        }
        return elements;
    };
    Placeholder.prototype.render = function () {
        return (React.createElement("div", { className: "rj-ev-list__placeholder" },
            React.createElement("div", { className: "rj-ev-list__placeholder__header" },
                React.createElement("div", { className: "rj-ev-list__placeholder__header-text" })),
            this.renderItems(this.props.eventsCount)));
    };
    return Placeholder;
}(React.PureComponent));
export { Placeholder };
//# sourceMappingURL=Placeholder.js.map